<app-tab-layout [loading]="loading()" [error]="error">
  @if (initialized()) {
    <app-api-table
      [name]="name"
      [endpoint]="endpoint()"
      [hasIndexCol]="true"
      [onRowClick]="openCallsAnalytics"
    ></app-api-table>
  }
</app-tab-layout>

<app-modal
  [title]="selectedCustomerName()"
  size="xl"
  [opened]="isAnalyticsModalOpen()"
  (closeTrigger)="onModalClose()"
>
  <div class="analytics-modal-content">
    @if (isAnalyticsLoading()) {
      <div class="modal-state loading">
        <app-inline-loader size="lg"></app-inline-loader>
      </div>
    } @else if (callsAnalytics().length === 0) {
      <div class="modal-state empty">
        <p>{{ dictionaryService.get('NoDataFound') }}</p>
      </div>
    } @else {
      <div class="call-list">
        @for (call of callsAnalytics(); track call.id) {
          <section class="call-card">
            <div class="call-meta">
              <p class="date" dir="ltr">{{ call.dateLabel }}</p>
              <h4>{{ call.product }}</h4>
              <p class="meta-row">
                <span class="label">{{ dictionaryService.get('Duration') }}:</span>
                <span class="value">{{ call.duration }}</span>
              </p>
              <p class="meta-row">
                <span class="label">{{ dictionaryService.get('Objection') }}:</span>
                <span class="value">{{ call.objection }}</span>
              </p>
              <p class="meta-row">
                <span class="label">{{ dictionaryService.get('Remark') }}:</span>
                <span class="value">{{ call.remarks }}</span>
              </p>
            </div>

            <div class="call-chart">
              <app-pie [data]="call.chartData" [disableAnimations]="true" [height]="420"></app-pie>
              <!-- <p class="chart-label">{{ dictionaryService.get('Duration') }}</p> -->
            </div>
          </section>
        }
      </div>
    }
  </div>
</app-modal>
